
import React,{useState,useEffect} from 'react'
import Dashboard from '../../components/dashboard/Dashboard'
import TaxComparison from '../../components/dashboard/TaxComparison'
import ReturnStatus from '../../components/dashboard/ReturnStatus'
import TaxableStatus from '../../components/dashboard/TaxableStatus'
import { motion } from 'framer-motion'
import UnderConstruction from '../../components/UnderConstruction'
import Section from '../../components/ui/ChapterSixDeduction'

const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value)
}
const DeductionChapterSix = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true)
    const [totalGrossSalary, setTotalGrossSalary] = useState()
    const [grossExpanded, setGrossExpanded] = useState(true)

    const [grossSalaryItems, setGrossSalaryItems] = useState([
      { id: 'a', label: '01. 80C - Life insurance premium, deferred annuity, contributions to provident fund, subscription to certain equity shares or debentures, etc.', value: '0.00' },
      { id: 'b', label: '02. 80CCC - Payment in respect Pension Fund', value: '0.00' },
      { id: 'b', label: '03. 80CCD(1) - Contribution to pension scheme of Central Government', value: '0.00' },
      { id: 'b', label: '04. 80CCD(1B) - Contribution to pension scheme of Central Government', value: '0.00' },
      { id: 'b', label: '05. 80CCD(2) - Contribution to pension scheme of Central Government by employer', value: '0.00' },
      { id: 'b', label: '06. 80CCG - Investment made under an equity savings scheme', value: '0.00' },
      { id: 'b', label: '07. 80D-Deduction in respect of Health Insurance premia. (Please fill 80D Schedule. This field is auto-populated from schedule 80D.): -', value: '0.00' },
      { id: 'b', label: '08. 80DD - Maintenance including medical treatment of a dependent who is a person with disability.(Please fill 80DD Schedule. This field is auto-populated from schedule 80DD.)', value: '0.00' },
      { id: 'b', label: '09. 80DDB - Medical treatment of specified disease', value: '0.00' },
      { id: 'b', label: '10. 80E - Interest on loan taken for higher education', value: '0.00' },
      { id: 'b', label: '11. 80EE - Interest on loan taken for residential house property', value: '0.00' },
      { id: 'b', label: '12. 80EEA-Deduction in respect of interest on loan taken for certain house property', value: '0.00' },
      { id: 'b', label: '13. 80EEB-Deduction in respect of purchase of electric vehicle', value: '0.00' },
      { id: 'b', label: '14. 80G - Donations to certain funds, charitable institutions, etc. (Please fill 80G Schedule. This field is auto-populated from schedule 80G.)', value: '0.00' },
      { id: 'b', label: '15. 80GG - Rent paid (Please submit form 10BA to claim deduction)', value: '0.00' },
      { id: 'b', label: '16. 80GGA - Certain donations for scientific research or rural development (Please fill 80GGA Schedule. This field is auto-populated from schedule 80GGA.)', value: '0.00' },
      { id: 'b', label: '17. 80GGC - Contribution to Political party. (Please fill 80GGC Schedule. This field is auto-populated from schedule 80GGC.)', value: '0.00' },
      { id: 'b', label: '18. 80 QQB - Royalty income of authors of certain books.', value: '0.00' },
      { id: 'b', label: '19. 80 RRB - Royalty on patents', value: '0.00' },
      { id: 'b', label: '20. 80TTA - Interest on saving bank Accounts in case of other than Resident senior citizens', value: '0.00' },
      { id: 'b', label: '21. 80TTB- Interest on deposits in case of Resident senior citizens', value: '0.00' },
      { id: 'b', label: '22. 80U - In case of a person with disability. (Please fill 80U Schedule. This field is auto-populated from schedule 80U.)', value: '0.00' },
      { id: 'b', label: '23. 80CCH-Contribution to Agnipath Scheme', value: '0.00' },
      { id: 'b', label: '24. Any Other deductions', value: '0.00' },
      { id: 'b', label: 'Total Deduction under Chapter VI', value: '0.00' },
     
    ])
  
    useEffect(()=>{
      const isSidebarOpen = localStorage.getItem('isSidebarOpen') === 'true'
      setIsSidebarOpen(isSidebarOpen)
    },[])
    
  return (
    <Dashboard>
       <Section
        title="Deduction Information"
        amount={formatCurrency(totalGrossSalary)}
        isExpanded={grossExpanded}
        onToggle={() => setGrossExpanded(!grossExpanded)}
        items={grossSalaryItems}
        isMenu={true}
        // onInputChange={(id, value) =>
        //   handleInputChange(setGrossSalaryItems, grossSalaryItems, id, value)
        // }
      />
    </Dashboard>
  )
}

export default DeductionChapterSix